/**
 * Crash lane 19 Oct 2026 (KATHY /browse/billing-summary 19:50Z; earlier KATHY 13 Oct + VAL 14 Oct
 * on /browse/receipt-maint): "Uncaught TypeError: Cannot read properties of null (reading
 * 'getColId')" at FilterManager.cachedFilter ← getCurrentFloatingFilterParentModel.
 *
 * It is an AG-Grid race, not PH10 code (mapped through a source-map rebuild of the deployed sha):
 * HeaderFilterCellCtrl.setupSyncWithFilter (ag-grid-community 32.3.9 main.esm.mjs:17442; the same
 * code is still in 33.3.2) queues `compPromise.then(comp => getCurrentFloatingFilterParentModel(
 * this.column))` for a column whose filter is active. When that header cell is torn down before
 * the floating-filter component finishes building (horizontal scroll moving the column out of the
 * viewport, a column hidden / re-shown, columnDefs replaced), destroy() sets `this.column = null`,
 * and the late resolution (ag-grid-react headerFilterCellComp userCompRef) dereferences it. The
 * throw happens in an async callback for a header cell that no longer exists — outside React's
 * render, so no error boundary, no blank screen, and the live header cell has its own, intact
 * promise. Nothing the user sees changes.
 *
 * PH10 cannot fix the library line without forking AG-Grid (new dependency ⇒ ADR), so the
 * window-level reporter tags it as a known race instead of logging it as a CLIENT ERROR crash.
 */
const SIGNATURE_MESSAGE = /Cannot read properties of null \(reading 'getColId'\)/;
const SIGNATURE_FRAME = /getCurrentFloatingFilterParentModel/;

export function isAgGridFloatingFilterRace(
  message: string | undefined | null,
  stack: string | undefined | null,
): boolean {
  if (!message || !stack) return false;
  return SIGNATURE_MESSAGE.test(message) && SIGNATURE_FRAME.test(stack);
}
